import { render, staticRenderFns } from "./SubSideMenuEntity.vue?vue&type=template&id=617a55bb"
import script from "./SubSideMenuEntity.vue?vue&type=script&lang=ts"
export * from "./SubSideMenuEntity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports